import { useQuery } from '@tanstack/react-query';
import * as apiPrimary from '@/apis/primary';
import { GeneralHook, FetchingStatus } from './types';

export type FeatureFlags = Record<
  string,
  {
    id: string;
    name: string;
    enabled: boolean;
    data: Record<string, unknown>;
  }
>;

const useFeatureFlags = (): GeneralHook<FeatureFlags> => {
  const { data, error, isError, isRefetching, isFetching, refetch, isLoading } = useQuery({
    queryFn: () => apiPrimary.getFeatureFlags(),
    queryKey: ['apiPrimary.getFeatureFlags'],
    retry: false,
    staleTime: 60 * 5 * 1000, // Refetches every 5 minutes if the app is open, if the app is closed and opened again it will refetch anyway
  });

  if (isLoading || isRefetching || isFetching) {
    return { fetchingStatus: FetchingStatus.LOADING };
  }

  if (isError) {
    return {
      fetchingStatus: FetchingStatus.ERROR,
      error,
      refetch,
    };
  }

  if (data?.data) {
    return {
      fetchingStatus: FetchingStatus.SUCCESS,
      data: data.data,
      refetch,
    };
  }

  return {
    fetchingStatus: FetchingStatus.INITIAL,
    fetch: refetch,
  };
};

export default useFeatureFlags;
